import instance from '../../../axios';
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';
import { getDataFromLocalStorage, getTokenFromLocalStorage } from 'utils/LocalStorage';

export const createFormValue = async (payload) => {
  try {
    let response = await instance.post(`/admin/template/value/create`, payload, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const getFormValues = async (payload = {}) => {
  try {
    let response = await instance.post(
      `/admin/template/value/get_value`,
      { ...payload },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};
export const getMultipleTicketFormValues = async (payload = {}) => {
  try {
    let response = await instance.post(
      `/admin/template/value/get_multiple_tickets_value`,
      { ...payload },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const editFormValues = async (payload) => {
  try {
    let response = await instance.put(`/admin/template/value/update`, payload, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const approveFormAttachments = async ({
  formId,
  ticketId,
  signatureURL,
  attachmentInstanceId,
}) => {
  try {
    let response = await instance.put(
      `/admin/template/value/approveFormAttachments`,
      { formId, ticketId, signature: signatureURL, attachmentInstanceId },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const getFormDefaultValues = async (payload) => {
  try {
    let response = await instance.post(
      `/admin/template/value/get_default_value`,
      { form_id: payload },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const createDefaultFormValue = async (payload) => {
  try {
    let response = await instance.post(
      `/admin/template/value/create_default`,
      { formData: payload },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const EditDefaultFormValue = async (fieldData) => {
  try {
    let response = await instance.put(
      `/admin/template/value/update_default`,
      { formData: fieldData },
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const saveDraftValue = async (payload) => {
  try {
    const response = await instance.post(`/admin/template/value/save_draft`, payload, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const getDraftValue = async (payload) => {
  try {
    const response = await instance.post(`/admin/template/value/get_draft`, payload, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const deleteDraftValue = async (payload) => {
  try {
    const response = await instance.post(`/admin/template/value/delete_draft`, payload, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};
